import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OnboardingService, PlatformService } from '@ld.consumer-portal/utils';

export const onboardingGuard: CanActivateFn = () => {
  const platformService = inject(PlatformService);
  const onboardingService = inject(OnboardingService);
  const router = inject(Router);

  if (!platformService.isNativeMobile()) {
    return true;
  }

  if (onboardingService.isOnboardingCompletedSync()) {
    return true;
  }

  return router.createUrlTree(['/onboarding']);
};
